/*
 * @Descripttion: 电商供应商订单发票录入页hooks
 * @Author: cb4786
 * @Date: 2023-08-10 17:06:46
 * @LastEditors: 曹博
 * @LastEditTime: 2023-11-30 14:00:28
 */
import { message } from 'antd'
import { useEffect, useReducer } from 'react'
import { orderStateDictInvert } from '.'
import {
  GET_INVOICE_PAYMENT_CANINVOICE,
  AllowAccountRes,
  DOWNLOAD_INVOICE_ACCEPT_TEMP,
} from '../../../api/orderManage'
import { history } from '../../../redux/store'
import {
  returnMoneyStatedictInvert,
  signVoucherStateDict,
} from '../../../tools/state'
import { formatTime, isResponseCodeSuccess } from '../../../tools/util'
import { customInvoiceEnum } from '../../../global/enums'
import _ from 'lodash'
import {
  State,
  initialState,
  reducer,
  setDataSourceAction,
  setInvoiceTipAction,
  setLoadingAction,
  setPagesAction,
  setSearchdataAction,
  setSelectedRowsAction,
} from './reducer'
import { useInvoiceEntryStore } from '@/stores/invoiceEntryStore'

export type AddFinacialData = {
  customer: string
  customerInvoice: string
  finalPrice: number
  id: string
  orderNo: string
  orderPrice: number
  orderState: string
  orderTime: string | number
  platform: string
  receiveMan: string
  returnState: string
  signVoucherState: string
  orderStatus?: string
}

const UseLanderInvoiceEntryHook = () => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { selectedRows } = state
  const setLanderInvoiceCount = useInvoiceEntryStore((state) => state.setLanderInvoiceCount)
  const handlePaginationChange = async (pageNo: number, pageSize?: number) => {
    dispatch(
      setPagesAction({
        pageNo: pageNo,
        pageSize: pageSize,
      }),
    )
    await getPageData({
      ...state,
      ...{
        pages: {
          pageNo: pageNo,
          pageSize: pageSize ? pageSize : 25,
        },
      },
    })
  }
  const handleTableChangeCheck = (
    selectedRowKeys: any,
    selectedRows: any[],
  ) => {
    dispatch(setSelectedRowsAction(selectedRows))
  }

  // 获取列表数据
  const getPageData = async (state: State) => {
    dispatch(setLoadingAction(true))
    dispatch(setSelectedRowsAction([]))
    const params = { ...state.pages, ...state.searchdata }
    const res = await GET_INVOICE_PAYMENT_CANINVOICE({
      ...params,
      // schemeId: params.schemeId,
      // orderNo: params.orderNo,
      // customer: params.customer,
      // receiveMan: params.receiveMan,
      // platform: params.platform,
      // signVoucher: params.signVoucher,
      // customerPayback: params.customerPayback,
      pageNo: params.pageNo,
      pageSize: params.pageSize,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resdata = convertTableState(res.data.content)
      const count = res.data.totalCount
      dispatch(
        setDataSourceAction({
          dataSource: { data: resdata, total: count },
          pageNo: res.data.pageNo,
        }),
      )
      // 更新zustand store中的count值
      setLanderInvoiceCount(count)
      dispatch(setLoadingAction(false))
    }
  }

  // 搜索
  const handleSearchClick = (params: any) => {
    dispatch(setSearchdataAction(params))
    getPageData({
      ...state,
      ...{
        searchdata: params,
      },
    })
  }

  // 整理数据
  const convertTableState = (dataSource: AllowAccountRes[]) => {
    return dataSource.map((item) => ({
      ...item,
      orderTime: formatTime(item.orderTime + ''),
      signVoucherState: (signVoucherStateDict as any)?.[item?.signVoucherState],
      customerInvoice:
        customInvoiceEnum.getDisplayTextByValue(item?.customerInvoice) ?? '-',
      orderStatus: orderStateDictInvert?.[item?.orderState]?.name ?? '-',
      returnState: returnMoneyStatedictInvert?.[item?.returnState]?.name ?? '-',
    }))
  }

  // 发票录入
  const handleBatchRecord = () => {
    if (selectedRows.length < 1) {
      message.warning('请先勾选可开票订单！')
      return
    }
    const titleList = _.uniq(
      selectedRows.map((item) => item.titleOfTheContract),
    )
    if (titleList.length > 1) {
      message.warning('不同签约抬头的发票不能合并开票')
      return
    }
    history.push('/srm/addInvoiceEntry', {
      data: selectedRows,
      type: 'lander',
      titleOfTheContract: titleList[0],
      orderType: '0',
    })
  }

  const changeInvoiceTip = (val: boolean) => {
    dispatch(setInvoiceTipAction(val))
  }

  // 明细导出
  const exportDetails = async () => {
    if (selectedRows.length < 1) {
      message.warning('请勾选需要导出明细的订单！')
      return
    }
    const idList = selectedRows.map((item) => item.id).join(',')
    await DOWNLOAD_INVOICE_ACCEPT_TEMP({ orderIds: idList })
  }
  useEffect(() => {
    getPageData(state)
  }, [])

  return {
    state,
    handlePaginationChange,
    handleTableChangeCheck,
    handleSearchClick,
    handleBatchRecord,
    changeInvoiceTip,
    exportDetails,
  }
}

export default UseLanderInvoiceEntryHook
/*
 * @Descripttion: 电商供应商订单发票录入页hooks
 * @Author: cb4786
 * @Date: 2023-08-10 17:06:46
 * @LastEditors: 曹博
 * @LastEditTime: 2023-11-30 14:00:28
 */
import { message } from 'antd'
import { useEffect, useReducer } from 'react'
import { orderStateDictInvert } from '.'
import {
  GET_INVOICE_PAYMENT_CANINVOICE,
  AllowAccountRes,
  DOWNLOAD_INVOICE_ACCEPT_TEMP,
} from '../../../api/orderManage'
import { history } from '../../../redux/store'
import {
  returnMoneyStatedictInvert,
  signVoucherStateDict,
} from '../../../tools/state'
import { formatTime, isResponseCodeSuccess } from '../../../tools/util'
import { customInvoiceEnum } from '../../../global/enums'
import _ from 'lodash'
import {
  State,
  initialState,
  reducer,
  setDataSourceAction,
  setInvoiceTipAction,
  setLoadingAction,
  setPagesAction,
  setSearchdataAction,
  setSelectedRowsAction,
} from './reducer'
import { useInvoiceEntryStore } from '@/stores/invoiceEntryStore'

export type AddFinacialData = {
  customer: string
  customerInvoice: string
  finalPrice: number
  id: string
  orderNo: string
  orderPrice: number
  orderState: string
  orderTime: string | number
  platform: string
  receiveMan: string
  returnState: string
  signVoucherState: string
  orderStatus?: string
}

const UseLanderInvoiceEntryHook = () => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { selectedRows } = state
  const setLanderInvoiceCount = useInvoiceEntryStore((state) => state.setLanderInvoiceCount)
  const handlePaginationChange = async (pageNo: number, pageSize?: number) => {
    dispatch(
      setPagesAction({
        pageNo: pageNo,
        pageSize: pageSize,
      }),
    )
    await getPageData({
      ...state,
      ...{
        pages: {
          pageNo: pageNo,
          pageSize: pageSize ? pageSize : 25,
        },
      },
    })
  }
  const handleTableChangeCheck = (
    selectedRowKeys: any,
    selectedRows: any[],
  ) => {
    dispatch(setSelectedRowsAction(selectedRows))
  }

  // 获取列表数据
  const getPageData = async (state: State) => {
    dispatch(setLoadingAction(true))
    dispatch(setSelectedRowsAction([]))
    const params = { ...state.pages, ...state.searchdata }
    const res = await GET_INVOICE_PAYMENT_CANINVOICE({
      ...params,
      // schemeId: params.schemeId,
      // orderNo: params.orderNo,
      // customer: params.customer,
      // receiveMan: params.receiveMan,
      // platform: params.platform,
      // signVoucher: params.signVoucher,
      // customerPayback: params.customerPayback,
      pageNo: params.pageNo,
      pageSize: params.pageSize,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resdata = convertTableState(res.data.content)
      const count = res.data.totalCount
      dispatch(
        setDataSourceAction({
          dataSource: { data: resdata, total: count },
          pageNo: res.data.pageNo,
        }),
      )
      // 更新zustand store中的count值
      setLanderInvoiceCount(count)
      dispatch(setLoadingAction(false))
    }
  }

  // 搜索
  const handleSearchClick = (params: any) => {
    dispatch(setSearchdataAction(params))
    getPageData({
      ...state,
      ...{
        searchdata: params,
      },
    })
  }

  // 整理数据
  const convertTableState = (dataSource: AllowAccountRes[]) => {
    return dataSource.map((item) => ({
      ...item,
      orderTime: formatTime(item.orderTime + ''),
      signVoucherState: (signVoucherStateDict as any)?.[item?.signVoucherState],
      customerInvoice:
        customInvoiceEnum.getDisplayTextByValue(item?.customerInvoice) ?? '-',
      orderStatus: orderStateDictInvert?.[item?.orderState]?.name ?? '-',
      returnState: returnMoneyStatedictInvert?.[item?.returnState]?.name ?? '-',
    }))
  }

  // 发票录入
  const handleBatchRecord = () => {
    if (selectedRows.length < 1) {
      message.warning('请先勾选可开票订单！')
      return
    }
    const titleList = _.uniq(
      selectedRows.map((item) => item.titleOfTheContract),
    )
    if (titleList.length > 1) {
      message.warning('不同签约抬头的发票不能合并开票')
      return
    }
    history.push('/srm/addInvoiceEntry', {
      data: selectedRows,
      type: 'lander',
      titleOfTheContract: titleList[0],
      orderType: '0',
    })
  }

  const changeInvoiceTip = (val: boolean) => {
    dispatch(setInvoiceTipAction(val))
  }

  // 明细导出
  const exportDetails = async () => {
    if (selectedRows.length < 1) {
      message.warning('请勾选需要导出明细的订单！')
      return
    }
    const idList = selectedRows.map((item) => item.id).join(',')
    await DOWNLOAD_INVOICE_ACCEPT_TEMP({ orderIds: idList })
  }
  useEffect(() => {
    getPageData(state)
  }, [])

  return {
    state,
    handlePaginationChange,
    handleTableChangeCheck,
    handleSearchClick,
    handleBatchRecord,
    changeInvoiceTip,
    exportDetails,
  }
}

export default UseLanderInvoiceEntryHook
